module.exports = __webpack_public_path__ + "img/ic_red_wrong.4a566a6d.svg";